import { motion } from "framer-motion";
import { User, ClipboardList, Handshake, Flag, HeartHandshake } from "lucide-react";

const roles = [
  { icon: User, title: "Player", desc: "Get back on the diamond and compete every weekend." },
  { icon: ClipboardList, title: "Manager", desc: "Lead a team, build a roster, run the bench." },
  { icon: Handshake, title: "Sponsor", desc: "Put your business behind local baseball." },
  { icon: Flag, title: "Umpire", desc: "Call the game and keep it fair and clean." },
  { icon: HeartHandshake, title: "Volunteer", desc: "Help grow the league however you can." },
];

export const Roles = () => {
  return (
    <section id="roles" data-testid="roles-section" className="relative py-24 lg:py-32 bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <span className="text-[#FF3B30] text-xs font-bold uppercase tracking-[0.3em]">Get Involved</span>
          <h2 className="text-4xl sm:text-5xl uppercase tracking-tighter mt-4 leading-[0.95]">
            There's A Spot For Everyone
          </h2>
          <p className="mt-6 text-[#8A94A0] text-lg font-medium">
            Playing, managing, sponsoring, umpiring or helping grow the league — pick your lane.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {roles.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.a
                href="#signup"
                key={r.title}
                data-testid={`role-card-${r.title.toLowerCase()}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="group bg-[#141414] border border-white/10 p-7 hover:border-[#FF3B30] hover:-translate-y-1 transition-all block"
              >
                <Icon className="text-white group-hover:text-[#FF3B30] transition-colors mb-5" size={36} strokeWidth={1.5} />
                <h3 className="text-xl uppercase tracking-tight mb-2">{r.title}</h3>
                <p className="text-sm text-[#8A94A0] font-medium leading-relaxed">{r.desc}</p>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
